document.addEventListener('DOMContentLoaded', () => {
  const QTY_OPTION_SELECTOR = 'input[name="options[Quantity]"]';

  function parseBottleQuantity(value) {
    const v = String(value || '');
    const match = v.match(/(\d+)\s*bottle/i);
    if (!match) return null;
    const qty = parseInt(match[1], 10);
    return Number.isFinite(qty) && qty > 0 ? qty : null;
  }

  function getFormForInput(input) {
    if (!input) return null;
    return input.closest('form') || null;
  }

  function setFormQuantity(form, quantity) {
    if (!form || !quantity) return;

    // Theme usually uses either a visible quantity input (.quantity__input)
    // or a hidden `<input name="quantity" value="1">` (e.g. quick buy / quick view).
    const quantityInput =
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('.quantity__input');

    if (quantityInput) quantityInput.value = String(quantity);

    // If there's a popout UI within the same form, keep it in sync.
    const quantityPopoutValue = form.querySelector('.select-popout__value[data-quantity-select]');
    const quantityPopoutItems = form.querySelectorAll('.select-popout__option[data-popout-option]');

    if (quantityPopoutValue) quantityPopoutValue.textContent = String(quantity);
    if (quantityPopoutItems && quantityPopoutItems.length) {
      quantityPopoutItems.forEach((item) => {
        const itemValue = parseInt(item.getAttribute('data-value'), 10);
        const li = item.closest('li');
        if (!li) return;
        if (itemValue === quantity) {
          li.classList.add('select-popout__item--current');
          item.setAttribute('aria-current', 'true');
        } else {
          li.classList.remove('select-popout__item--current');
          item.removeAttribute('aria-current');
        }
      });
    }
  }

  function syncFromCheckedQuantityOption(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(QTY_OPTION_SELECTOR).forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.checked) return;
      const quantity = parseBottleQuantity(input.value);
      if (!quantity) return;
      const form = getFormForInput(input);
      setFormQuantity(form, quantity);
    });
  }

  // Delegated change handler (works for dynamically-injected quick view / drawers).
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches(QTY_OPTION_SELECTOR)) return;
    if (!target.checked) return;
    const quantity = parseBottleQuantity(target.value);
    if (!quantity) return;
    const form = getFormForInput(target);
    setFormQuantity(form, quantity);
  });

  // Keep popout UI in sync when user manually edits visible quantity.
  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('.quantity__input')) return;
    const form = getFormForInput(target);
    const qty = parseInt(target.value, 10);
    if (!Number.isFinite(qty) || qty <= 0) return;
    setFormQuantity(form, qty);
  });

  // Initial sync on page load (PDP, featured sections, etc.).
  syncFromCheckedQuantityOption(document);

  // Watch for dynamically inserted quick view content and sync immediately.
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.querySelector && node.querySelector(QTY_OPTION_SELECTOR)) {
          syncFromCheckedQuantityOption(node);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
});
